import { Link, useLocation, useSearchParams } from 'react-router-dom'

import { useBvaDetails } from 'api/queries/useBvaDetails'
import { BVAphases } from 'constants/HomeConstants'
import { parseBvaDetailsParam, unslugify } from 'utils/bvaSlug'

interface BreadcrumbItem {
  label: string
  to: string
}

export const Breadcrumb = () => {
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const path = location.pathname
  const sections = path.split('/')
  const activePhase = BVAphases.find(phase => searchParams.has(phase.title))
  const homeUrl = process.env.REACT_APP_HOME_URL || '/'

  const isBrandListRoute = path === '/BVAFrameworks'
  const isProcessRoute = path === '/process'
  const isBrandDetailsRoute = /^\/[^/]+$/.test(path) && !isBrandListRoute && !isProcessRoute

  const { id: detailsId, namePart } = parseBvaDetailsParam(isBrandDetailsRoute ? sections[1] : undefined)
  const { data: bvaDetails } = useBvaDetails(detailsId || undefined)

  const items: BreadcrumbItem[] = [{ label: 'Brand Vision Architecture', to: '/' }]

  if (isProcessRoute) {
    items.push({ label: activePhase?.title || 'Process', to: '/process' })
  } else if (isBrandListRoute) {
    items.push({ label: 'BVA Frameworks', to: '/BVAFrameworks' })
  } else if (isBrandDetailsRoute) {
    const brandLabel = bvaDetails?.brandName || (namePart ? unslugify(namePart) : sections[1])
    items.push({ label: 'BVA Frameworks', to: '/BVAFrameworks' }, { label: brandLabel, to: path })
  }

  return (
    <div className="fixed z-80 bg-white w-full pl-4 md:pl-10 lg:pl-[72px] py-2 font-TCCC text-[14px] font-medium text-[#4D5358] border-solid border-b-[#FFFFFF] flex items-center gap-3 overflow-x-auto whitespace-nowrap">
      <a href={homeUrl} className="breadcrumb-clickable body-s">
        Home
      </a>
      {items.map((item, idx) => {
        const isCurrent = idx === items.length - 1
        return (
          <span key={item.to} className="flex items-center gap-3">
            <span>/</span>
            {isCurrent ? (
              <span className="breadcrumb-not-clickable body-s">{item.label}</span>
            ) : (
              <Link className="breadcrumb-clickable body-s text-color-neutral-80" to={item.to}>
                {item.label}
              </Link>
            )}
          </span>
        )
      })}
    </div>
  )
}
